<template>
  <template v-if="hasMobileAndDesktopLayouts">
    <template v-if="mq.mdPlus">
      <component
        :is="component(item)"
        v-for="(item, index) in article.desktop"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <component
            :is="component(element)"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            v-bind="element.props"
            :class="element.class"
            :style="element.style"
          >
            {{ element.text }}
          </component>
        </template>
      </component>
    </template>

    <template v-else>
      <component
        :is="component(item)"
        v-for="(item, index) in article.mobile"
        :key="index"
        v-bind="item.props"
        :style="item.style"
      >
        <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
          <component
            :is="component(element)"
            v-for="(element, elementIndex) in slot"
            :key="elementIndex"
            v-bind="element.props"
            :class="element.class"
            :style="element.style"
          >
            {{ element.text }}
          </component>
        </template>
      </component>
    </template>
  </template>
  <template v-else>
    <component
      :is="component(item)"
      v-for="(item, index) in article.content"
      :key="index"
      v-bind="item.props"
      :style="item.style"
    >
      <template v-for="(slot, key) in slotContent(item)" #[key] :key="key">
        <component
          :is="component(element)"
          v-for="(element, elementIndex) in slot"
          :key="elementIndex"
          v-bind="element.props"
          :class="element.class"
          :style="element.style"
        >
          {{ element.text }}
        </component>
      </template>
    </component>
  </template>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "Headless",
  inject: ["mq"],
  props: {
    articleHandle: {
      type: String,
      required: true,
    },
  },
  computed: {
    article() {
      return require(`@/content/${this.articleHandle}.json`);
    },
    hasMobileAndDesktopLayouts() {
      return (
        Object.prototype.hasOwnProperty.call(this.article, "mobile") &&
        Object.prototype.hasOwnProperty.call(this.article, "desktop")
      );
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }

      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot;
    },
  },
};
</script>
